const config = {
    addrs: {Kyv: "terra1yx6fn63y8veag84eq30j578p78kgrs2u457vsc",},
    env: {
        fcdUrl: "https://fcd.terra.dev/",
        chainId: "columbus-5",
        sdTokenPrice: 0.43,
        environment: "mainnet",
    },
};

module.exports = {config};
